import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterLink } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-pagenotfound',
  imports: [ButtonModule, RouterLink],
  templateUrl: './pagenotfound.component.html',
  styleUrl: './pagenotfound.component.scss',
})
export class PagenotfoundComponent implements OnInit, OnDestroy {
  private readonly title = inject(Title);

  ngOnInit(): void {
    this.title.setTitle('Page not found');
  }

  ngOnDestroy(): void {
    this.title.setTitle('Portal App');
  }
}
